import React from 'react';
import {useParams} from 'react-router-dom';
import {ClientHeader} from './ClientHeader';
import {ClientTabs} from './ClientTabs';
import {DataExplorerPage} from '../data_explorer/DataExplorerPage';
import {APIClient} from '../../utils/APIClient';
import {API_URL} from '../../settings/local_settings';

class ClientDataExplorerInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            clientName: '',
        };
    }

    componentDidMount() {
        new APIClient(API_URL + 'agency-client/' + this.props.clientId + '/').call('GET').then((data) => {
            if (data.status === 'OK') {
                this.setState({clientName: data.agency_client.name});
            }
        });
    }

    render() {
        const {clientId} = this.props;

        return (
            <section className="section-content client-workspace-page">
                <ClientHeader name={this.state.clientName}/>
                <ClientTabs clientId={clientId}/>
                <DataExplorerPage fixedClientId={clientId}/>
            </section>
        );
    }
}

export function ClientDataExplorer() {
    const {id} = useParams();
    return <ClientDataExplorerInner clientId={id}/>;
}
